import { BsGear } from 'react-icons/bs'
import {
  MdOutlineInventory2,
  MdOutlineLocalShipping,
} from 'react-icons/md'
import { GrCatalog } from 'react-icons/gr'
import {
  AiOutlineHome,
  AiOutlineShop,
  AiOutlineDashboard,
  AiOutlineFilePpt,
  AiOutlineOrderedList,
  AiOutlineShoppingCart,
} from 'react-icons/ai'
import { GiFactory } from 'react-icons/gi'
import { MdProductionQuantityLimits } from 'react-icons/md'
import { HiOutlineDocumentReport } from 'react-icons/hi'
import { FiBook } from 'react-icons/fi'
import { BiPurchaseTagAlt } from 'react-icons/bi'
import { BsKanban } from 'react-icons/bs'
import { FaSitemap, FaRegFile } from "react-icons/fa";
import { FcSupport } from "react-icons/fc";
import { FaRegDotCircle } from "react-icons/fa";
import { FaRegImages } from "react-icons/fa";
import { FaImage } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import { FaAlignLeft } from "react-icons/fa";
import { AiOutlineFilePdf } from "react-icons/ai";
import { FaTshirt } from "react-icons/fa";

const icons = {
  BsGear: <BsGear />,
  MdOutlineInventory2: <MdOutlineInventory2 />,
  MdOutlineLocalShipping: <MdOutlineLocalShipping />,
  GrCatalog: <GrCatalog />,
  AiOutlineHome: <AiOutlineHome />,
  AiOutlineShop: <AiOutlineShop />,
  GiFactory: <GiFactory />,
  MdProductionQuantityLimits: <MdProductionQuantityLimits />,
  HiOutlineDocumentReport: <HiOutlineDocumentReport />,
  FiBook: <FiBook />,
  AiOutlineDashboard: <AiOutlineDashboard />,
  AiOutlineFilePpt: <AiOutlineFilePpt />,
  BiPurchaseTagAlt: <BiPurchaseTagAlt />,
  AiOutlineOrderedList: <AiOutlineOrderedList />,
  AiOutlineShoppingCart: <AiOutlineShoppingCart />,
  BsKanban: <BsKanban />,
  FaSitemap: <FaSitemap />,
  FcSupport: <FcSupport />,
  FaRegFile: <FaRegFile />,
  FaRegDotCircle: <FaRegDotCircle />,
  FaRegImages: <FaRegImages />,
  FaImage: <FaImage />,
  FaRegStar: <FaRegStar />,
  FaAlignLeft: <FaAlignLeft />,
  AiOutlineFilePdf: <AiOutlineFilePdf />,
  FaTshirt: <FaTshirt />,
}

export default icons
